// 深链（邀请链接）统一生成与解析，保证生成端与接收端格式一致。
export const APP_URL_SCHEME = 'kendamabox';

export interface RoomInvite {
  roomId: string;
  password?: string;
}

export function buildRoomInviteLink(roomId: string, password?: string): string {
  const params = new URLSearchParams();
  params.set('roomId', roomId);
  if (password) params.set('password', password);
  return `${APP_URL_SCHEME}://room?${params.toString()}`;
}

export function parseRoomInvite(rawUrl: string): RoomInvite | null {
  if (!rawUrl) return null;
  try {
    const url = new URL(rawUrl);
    const roomId = url.searchParams.get('roomId');
    if (!roomId) return null;
    const password = url.searchParams.get('password') || undefined;
    return { roomId, password };
  } catch {
    return null;
  }
}
